module.exports = new __parcel__URL__("trojan-avocado.aa87639f.webp").toString();